<script lang="ts">
    import '../app.css';
    import Nav from '$lib/components/layout/Nav.svelte';
    import Footer from '$lib/components/layout/Footer.svelte';
    import AnnouncementBar from '$lib/components/layout/AnnouncementBar.svelte';
    import BackgroundLayers from '$lib/components/layout/BackgroundLayers.svelte';
    import ContactModal from '$lib/components/ui/ContactModal.svelte';
    import { page } from '$app/stores';

    let { children } = $props();

    const canonicalBase = 'https://admrl.co';
</script>

<svelte:head>
    <link rel="canonical" href="{canonicalBase}{$page.url.pathname}" />
    <meta property="og:site_name" content="Admiral" />
    <meta property="og:locale" content="en_US" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="{canonicalBase}{$page.url.pathname}" />
    <meta name="twitter:site" content="@admrl_co" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="robots" content="index, follow" />
</svelte:head>

<BackgroundLayers />
<AnnouncementBar />

<div class="w-full overflow-x-hidden">
    <header
        class="m-auto flex w-full flex-col px-4 mq-450:px-[32px] mq-580:px-11 lg:px-12 mq-1300:px-0"
    >
        <Nav />
    </header>

    <main>
        {@render children()}
    </main>

    <Footer />
</div>

<ContactModal />
